import { render, staticRenderFns } from "./ArticleContentYjj.vue?vue&type=template&id=4d9811d5&scoped=true&"
import script from "./ArticleContentYjj.vue?vue&type=script&lang=js&"
export * from "./ArticleContentYjj.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContentYjj.vue?vue&type=style&index=0&id=4d9811d5&prod&scoped=true&lang=css&"
import style1 from "./ArticleContentYjj.vue?vue&type=style&index=1&id=4d9811d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9811d5",
  null
  
)

export default component.exports